function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,64.09c-13.53,0-24.53-11.01-24.53-24.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,11.87,9.66,21.53,21.53,21.53s21.54-9.66,21.54-21.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,13.53-11.01,24.53-24.54,24.53Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 38.5,
  y: 62.59,
  width: 3,
  height: 7.71
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M56.27,71.8H23.73c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h32.54c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M49.63,42.9c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07s0-.03,0-.05v-2.3h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07v-2.35h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07v-2.3s0-.03,0-.05h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.8c-1.46-8.86-9.16-15.65-18.43-15.65s-16.97,6.79-18.43,15.65h8.8c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07s0,.03,0,.05v2.3h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07v2.35h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07v2.3s0,.03,0,.05h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-8.8c1.46,8.86,9.16,15.65,18.43,15.65s16.97-6.79,18.43-15.65h-8.8Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/GameShows-active.85d975a9.svg";
export { SvgComponent as ReactComponent };